import { render, staticRenderFns } from "./OfficeContextMenuComponent.vue?vue&type=template&id=c30ca77a"
import script from "./OfficeContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OfficeContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c30ca77a')) {
      api.createRecord('c30ca77a', component.options)
    } else {
      api.reload('c30ca77a', component.options)
    }
    module.hot.accept("./OfficeContextMenuComponent.vue?vue&type=template&id=c30ca77a", function () {
      api.rerender('c30ca77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/components/OfficeContextMenu/OfficeContextMenuComponent.vue"
export default component.exports